// extracted by mini-css-extract-plugin
export var attribution = "_ar-4";
export var authorName = "_ar-5";
export var quote = "_ar-3";
export var testimonial = "_ar-2";
export var trustedBy = "_ar-0";
export var trustedByLabel = "_ar-1";